import { useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Autocomplete,
  Marker,
} from "@react-google-maps/api";

const libraries = ["places"];
const defaultCenter = { lat: 28.6139, lng: 77.2090 }; // Delhi

const GoogleMapSelector = ({ setLatLng, setAddress, setFieldValue }) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [marker, setMarker] = useState(defaultCenter);

  const handlePlaceChanged = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();
    if (!place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    setMarker({ lat, lng });

    setFieldValue("latitude_manually", lat);
    setFieldValue("longitude_manually", lng);
    setLatLng({ lat, lng });
    setAddress(place.formatted_address || "");
  };

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setMarker({ lat, lng });

    setFieldValue("latitude_manually", lat);
    setFieldValue("longitude_manually", lng);
    setLatLng({ lat, lng });

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        setAddress(results[0].formatted_address);
      }
    });
  };

  return (
   
      <div className="map-wrapper" style={{ position: "relative" }}>

        {/* Search Box */}
        <div className="search-box-container">
          <Autocomplete onLoad={setAutocomplete} onPlaceChanged={handlePlaceChanged}>
            <input
              type="text"
              placeholder="Search location..."
              className="search-box-input"
            />
          </Autocomplete>
        </div>

        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "400px" }}
          center={marker}
          zoom={14}
          onClick={handleMapClick}
          options={{
            tilt: 0,
            gestureHandling: 'auto'
          }}
        >
          <Marker 
            position={marker}
            key={`${marker.lat}-${marker.lng}`}
            title="Selected Location"
          />
        </GoogleMap>

      </div>

  );
};

export default GoogleMapSelector;
